import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { NAVIGATION_CONSTANTS } from '../constants/navigation';

export const useNavigationActions = () => {
  const navigate = useNavigate();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const targetPosition = element.offsetTop - NAVIGATION_CONSTANTS.NAV_HEIGHT;
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  };

  const navigateToSection = (sectionId) => {
    // If we're already on the homepage, just scroll
    if (window.location.pathname === '/') {
      scrollToSection(sectionId);
      return;
    }

    // Navigate to homepage with scroll target in state
    navigate('/', { state: { scrollTo: sectionId } });
  };

  const handleLogoClick = () => {
    if (window.location.pathname === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate('/');
    }
  };

  return {
    scrollToSection,
    navigateToSection,
    handleLogoClick
  };
};